// extracted by mini-css-extract-plugin
export default {"backBtn":"style_backBtn__pBZQB","heading":"style_heading__MZ8+m"};